import { Component, Input, OnInit, inject } from '@angular/core';
import {
  IActivo,
  IFilter,
  ILogTrackeo,
  IPopulate,
  IQueryParam,
} from 'modelos/src';
import { Subscription } from 'rxjs';
import { IColumnas } from '../../../../../../auxiliares/tabla/tabla.component';
import { HelperService } from '../../../../../../auxiliares/servicios/helper.service';
import { Lista2Service } from '../../../../../../auxiliares/servicios/lista2.service';

@Component({
  selector: 'app-listado-logs-trackeos',
  templateUrl: './listado-logs-trackeos.component.html',
  styleUrl: './listado-logs-trackeos.component.scss',
  standalone: false,
})
export class ListadoLogsTrackeosComponent implements OnInit {
  helper = inject(HelperService);
  private lista2 = inject(Lista2Service);

  @Input() vehiculo?: IActivo;

  //// Tabla nueva
  public name = 'ListadoLogsTrackeosComponent';
  public logs?: ILogTrackeo[];
  public logs$?: Subscription;
  public totalCount = 0;
  public columnas?: IColumnas<ILogTrackeo>[];

  public filter: IFilter<ILogTrackeo> = {};
  public populate: IPopulate = {
    path: 'cliente',
    select: 'nombre',
  };
  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    populate: JSON.stringify(this.populate),
    sort: '-fecha',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
  };

  public async listar(): Promise<void> {
    if (!this.vehiculo?._id) return;
    const filter = HelperService.stringToObject(this.query.filter);
    filter['idActivo'] = this.vehiculo._id;
    this.query.filter = JSON.stringify(filter);

    this.logs$?.unsubscribe();
    this.logs$ = this.lista2.logTrackeos(this.query, 30).subscribe((data) => {
      this.totalCount = data.totalCount;
      this.logs = data.datos;
    });
  }

  // Tabla

  private setColumnas() {
    this.columnas = [
      {
        header: {
          label: 'Fecha de creación',
          sortable: true,
          sort: 'fecha',
        },
        row: {
          fecha: (dato) => dato.fecha,
          hace: true,
          noData: 'Sin fecha',
        },
      },
      // {
      //   header: {
      //     label: 'Parada Trackeo',
      //     sortable: true,
      //   },
      //   row: {
      //     field: 'ultimaParada',
      //   },
      // },
      {
        header: {
          label: 'Parada trackeo #',
        },
        row: {
          parse(dato) {
            if (!HelperService.isDefined(dato.indexUltimaParada))
              return undefined;
            return dato.indexUltimaParada! + 1;
          },
          noData: 'Sin parada',
        },
      },
      {
        header: {
          label: 'Parada actual',
          sortable: true,
        },
        row: {
          field: 'paradaActual',
          noData: 'Sin parada actual',
        },
      },
      {
        header: {
          label: '#',
        },
        row: {
          parse(dato) {
            if (!HelperService.isDefined(dato.indexParadaActual))
              return undefined;
            return dato.indexParadaActual! + 1;
          },
          noData: 'Sin parada',
        },
      },
      {
        header: {
          label: 'Parada nueva',
        },
        row: {
          field: 'nuevaParada',
          noData: 'Sin parada nueva',
        },
      },
      {
        header: {
          label: 'Motivo',
        },
        row: {
          field: 'motivo',
          noData: 'Sin motivo',
        },
      },
    ];
  }

  async ngOnInit() {
    this.setColumnas();
    await this.listar();
  }
}
